module.exports = __webpack_public_path__ + "img/renli3.93fd17c1.png";